import { render, staticRenderFns } from "./AssetStateBadge.vue?vue&type=template&id=1dd6e085&scoped=true&"
import script from "./AssetStateBadge.vue?vue&type=script&lang=ts&"
export * from "./AssetStateBadge.vue?vue&type=script&lang=ts&"
import style0 from "./AssetStateBadge.vue?vue&type=style&index=0&id=1dd6e085&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd6e085",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
